// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalQuestionBuilder_root__M-b0T"};